export enum SkeletonPage {
    Home = 'Home',
    Event = 'Event',
    Favourites = 'Favourite',
    Live = 'Live',
    Coupon = 'Coupon',
    Competition = 'Competition',
    UpComing = 'Upcoming',
    Racing = 'Racing',
    RacingTomorrow = 'RacingTomorrow',
    RacingForecast = 'RacingForecast',
}
